import { BreakpointObserver, Breakpoints } from '@angular/cdk/layout';
import { Component, Input, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { User } from 'app/models';
import { Subscription } from 'rxjs';
import { ChronoPipe } from 'app/modules/dashboard/pipes/chrono.pipe';
import { TranslateModule } from '@ngx-translate/core';
import { PositionItemComponent } from '../positionItem/positionItem.component';
import { NgIf, NgClass, DatePipe, Location } from '@angular/common';

@Component({
  selector: 'app-user-position',
  templateUrl: './userPosition.component.html',
  styleUrls: ['./userPosition.component.scss'],
  standalone: true,
  imports: [
    NgIf,
    NgClass,
    PositionItemComponent,
    TranslateModule,
    DatePipe,
    ChronoPipe,
  ],
})
export class UserPositionComponent implements OnInit, OnDestroy {
  @Input() userLogged: User | null;
  @Input() userRank: any | null;

  subscriptions: Subscription[] = [];

  // RESPONSIVE
  xSmallScreen: boolean;
  // ---

  constructor(
    private responsive: BreakpointObserver,
    private router: Router,
    private location: Location
  ) {}
  navToActivity(activityId: number): void {
    this.router.navigate(['browse', 'training-log', activityId]).then(() => {
      this.location.go(this.router.url);
      window.location.reload();
    });
  }

  ngOnInit(): void {
    this.subscriptions = [
      this.responsive.observe(Breakpoints.XSmall).subscribe((result) => {
        this.xSmallScreen = result.matches ? true : false;
      }),
    ];
  }

  ngOnDestroy(): void {
    this.subscriptions.forEach((sub) => sub.unsubscribe());
  }
}
